import React, { type ReactNode } from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { TabbedAgentSessionsLoadable } from './TabbedAgentSessionsLoadable.ts';
import { AgentsWaitingForYourInputSection } from './AgentsWaitingForYourInputSection.tsx';

export function AgentSessionsContainer({
	children,
}: AgentSessionsContainerProps): React.JSX.Element {
	const { isAdminHubAIEnabled, isAIEarlyAccessEnabled, isLoggedIn, userId } = useSessionData();
	const isTabbed =
		isLoggedIn &&
		!!userId &&
		isAdminHubAIEnabled &&
		isAIEarlyAccessEnabled &&
		expValEquals('cc_ai_agentic_sessions', 'version', 3);

	return isTabbed ? (
		<TabbedAgentSessionsLoadable>{children}</TabbedAgentSessionsLoadable>
	) : (
		<>
			{children(false)}
			<AgentsWaitingForYourInputSection />
		</>
	);
}

type AgentSessionsContainerProps = {
	children: (isTabbed: boolean) => ReactNode;
};
